<template>
  <form>
    <div class="input-group-sm input-group mb-3">
      <div class="input-group-prepend">
        <label class="input-group-text" for="resultat_resultat">resultat</label>
      </div>
      <select id="resultat_resultat" class="custom-select" disabled name="resultat_resultat">
        <option>
          {{ (equipe_a) ? equipe_a.nom.toUpperCase() : '' }} -
          {{ (equipe_b) ? equipe_b.nom.toUpperCase() : '' }}
          ({{
            (resultat) ? (new Date(resultat.date_rencontre).toLocaleDateString() + ' - ' + resultat.temps_rencontre) : ''
          }})
        </option>
      </select>
    </div>
    <div class="input-group-sm input-group mb-3">
      <div class="input-group-prepend">
        <label class="input-group-text" for="resultat_equipe_a">Equipe domiciliée</label>
      </div>
      <select id="resultat_equipe_a" class="custom-select" disabled name="resultat_equipe_a">
        <option>{{ (equipe_a) ? equipe_a.nom.toUpperCase() : '' }}</option>
      </select>
    </div>
    <div class="input-group-sm input-group mb-3">
      <div class="input-group-prepend">
        <span class="input-group-text">Score équipe domiciliée</span>
      </div>
      <input id="resultat_score_equipe_a" :value="resultat.score_equipe_a" class="form-control" disabled
             name="resultat_score_equipe_a" type="text">
    </div>
    <div class="input-group-sm input-group mb-3">
      <div class="input-group-prepend">
        <label class="input-group-text" for="resultat_equipe_b">Equipe visiteuse</label>
      </div>
      <select id="resultat_equipe_b"
              class="custom-select"
              disabled
              name="resultat_equipe_b">
        <option>{{ (equipe_b) ? equipe_b.nom.toUpperCase() : '' }}</option>
      </select>
    </div>
    <div class="input-group-sm input-group mb-3">
      <div class="input-group-prepend">
        <span class="input-group-text">Score équipe visiteuse</span>
      </div>
      <input id="resultat_score_equipe_b"
             :value="resultat.score_equipe_b"
             class="form-control"
             disabled
             name="resultat_score_equipe_b"
             type="text">
    </div>
    <div class="input-group-sm input-group mb-3">
      <div class="input-group-prepend">
        <label class="input-group-text" for="resultat_date_rencontre">Date et Temps de rencontre</label>
        <label class="input-group-text" for="resultat_temps_rencontre"></label>
      </div>
      <input id="resultat_date_rencontre"
             :value="(resultat) ? resultat.date_rencontre : ''"
             disabled
             class="form-control"
             name="resultat_date_rencontre"
             type="date">
      <input id="resultat_temps_rencontre"
             :value="(resultat) ? resultat.temps_rencontre : ''"
             disabled
             class="form-control"
             name="resultat_temps_rencontre"
             type="time">
    </div>
    <div class="input-group-sm input-group mb-3">
      <div class="input-group-prepend">
        <label class="input-group-text" for="resultat_terrain">Terrain</label>
      </div>
      <select id="resultat_terrain"
              class="custom-select"
              disabled
              name="resultat_terrain">
        <option>{{ (terrain) ? terrain.nom : '' }}</option>
      </select>
    </div>
    <div class="input-group-sm input-group mb-3">
      <div class="input-group-append">
        <label class="input-group-text" for="resultat_arbitre_principal">Arbitre Principal</label>
      </div>
      <select id="resultat_arbitre_principal"
              class="custom-select"
              disabled
              name="resultat_arbitre_principal">
        <option>
          {{ (arbitre_principal && arbitre_principal.prenom && arbitre_principal.postnom && arbitre_principal.nom) ?
            (
                arbitre_principal.prenom.charAt(0).toUpperCase() + arbitre_principal.prenom.slice(1).toLowerCase() + ' ' +
                arbitre_principal.postnom.charAt(0).toUpperCase() + arbitre_principal.postnom.slice(1).toLowerCase() + ' ' +
                arbitre_principal.nom.charAt(0).toUpperCase() + arbitre_principal.nom.slice(1).toLowerCase()
            ) : '' }}
        </option>
      </select>
    </div>
    <div class="input-group-sm input-group mb-3">
      <div class="input-group-prepend">
        <label class="input-group-text" for="resultat_arbitre_assistant_1">Arbitre Assistant 1</label>
      </div>
      <select id="resultat_arbitre_assistant_1"
              disabled
              class="custom-select"
              name="resultat_arbitre_assistant_1">
        <option>
          {{ (arbitre_assistant_1 && arbitre_assistant_1.prenom && arbitre_assistant_1.postnom && arbitre_assistant_1.nom) ?
            (
                arbitre_assistant_1.prenom.charAt(0).toUpperCase() + arbitre_assistant_1.prenom.slice(1).toLowerCase() + ' ' +
                arbitre_assistant_1.postnom.charAt(0).toUpperCase() + arbitre_assistant_1.postnom.slice(1).toLowerCase() + ' ' +
                arbitre_assistant_1.nom.charAt(0).toUpperCase() + arbitre_assistant_1.nom.slice(1).toLowerCase()
            ) : 'Aucun arbitre programmé ! ' }}
        </option>
      </select>
    </div>
    <div class="input-group-sm input-group mb-3">
      <div class="input-group-prepend">
        <label class="input-group-text" for="resultat_arbitre_assistant_2">Arbitre Assistant 2</label>
      </div>
      <select id="resultat_arbitre_assistant_2"
              disabled
              class="custom-select"
              name="resultat_arbitre_assistant_2">
        <option>
          {{ (arbitre_assistant_2 && arbitre_assistant_2.prenom && arbitre_assistant_2.postnom && arbitre_assistant_2.nom) ?
            (
                arbitre_assistant_2.prenom.charAt(0).toUpperCase() + arbitre_assistant_2.prenom.slice(1).toLowerCase() + ' ' +
                arbitre_assistant_2.postnom.charAt(0).toUpperCase() + arbitre_assistant_2.postnom.slice(1).toLowerCase() + ' ' +
                arbitre_assistant_2.nom.charAt(0).toUpperCase() + arbitre_assistant_2.nom.slice(1).toLowerCase()
            ) : '' }}
        </option>
      </select>
    </div>
    <div class="input-group-sm input-group mb-3">
      <div class="input-group-prepend">
        <label class="input-group-text" for="resultat_arbitre_commissaire">Arbitre Commissaire</label>
      </div>
      <select id="resultat_arbitre_commissaire"
              disabled
              class="custom-select"
              name="resultat_arbitre_commissaire">
        <option>
          {{ (arbitre_commissaire && arbitre_commissaire.prenom && arbitre_commissaire.postnom && arbitre_commissaire.nom) ?
            (
                arbitre_commissaire.prenom.charAt(0).toUpperCase() + arbitre_commissaire.prenom.slice(1).toLowerCase() + ' ' +
                arbitre_commissaire.postnom.charAt(0).toUpperCase() + arbitre_commissaire.postnom.slice(1).toLowerCase() + ' ' +
                arbitre_commissaire.nom.charAt(0).toUpperCase() + arbitre_commissaire.nom.slice(1).toLowerCase()
            ) : '' }}
        </option>
      </select>
    </div>
    <div class="input-group-sm input-group mb-3">
      <div class="input-group-prepend">
        <label class="input-group-text" for="resultat_saison">Saison</label>
      </div>
      <select id="resultat_saison"
              disabled
              class="custom-select"
              name="resultat_saison">
        <option>
          {{ (saison) ? (saison.annee_debut + ' - ' +
            saison.annee_fin): '' }}
        </option>
      </select>
    </div>
    <div class="input-group-sm input-group mb-3">
      <div class="input-group-prepend">
        <label class="input-group-text" for="resultat_championnat">Championnat</label>
      </div>
      <select id="resultat_championnat"
              disabled
              class="custom-select"
              name="resultat_championnat">
        <option>
          {{ (championnat) ? championnat.nom : '' }}
        </option>
      </select>
    </div>
    <div class="input-group-sm input-group mb-3">
      <div class="input-group-prepend">
        <label class="input-group-text" for="resultat_phase">Phase</label>
      </div>
      <select id="resultat_phase"
              disabled
              class="custom-select"
              name="resultat_phase">
        <option value="aller">{{ (resultat) ? resultat.phase : '' }}</option>
      </select>
    </div>
    <div class="input-group-sm input-group mb-3">
      <div class="input-group-prepend">
        <label class="input-group-text" for="resultat_journee">Journée</label>
      </div>
      <input id="resultat_journee"
             class="form-control"
             disabled
             :value="(resultat) ? resultat.journee : ''"
             name="resultat_journee"
             type="number">
    </div>
    <div class="input-group-sm input-group mb-3">
      <div class="input-group-prepend">
        <span class="input-group-text">Date et Temps de creation</span>
      </div>
      <input :value="resultat.date_creation"
             name="resultat_date_creation"
             disabled
             type="date"
             class="form-control">
      <input :value="resultat.temps_creation"
             name="resultat_temps_creation"
             disabled
             type="time"
             class="form-control">
    </div>
    <div class="input-group-sm input-group mb-3">
      <div class="input-group-prepend">
        <span class="input-group-text">Date et Temps de mise à jour</span>
      </div>
      <input :value="resultat.date_modification"
             name="resultat_date_modification"
             disabled
             type="date"
             class="form-control">
      <input :value="resultat.temps_modification"
             name="resultat_temps_modification"
             disabled
             type="time"
             class="form-control">
    </div>
  </form>
</template>

<script>
import {mapActions, mapGetters, mapMutations} from 'vuex'

export default {
  name: "Read",
  props: {
    resultat: {
      type: Object
    }
  },
  data() {
    return {
      equipe_a: null,
      equipe_b: null,
      terrain: null,
      arbitre_principal: null,
      arbitre_assistant_1: null,
      arbitre_assistant_2: null,
      arbitre_commissaire: null,
      saison: null,
      championnat: null,
      phase: null,
      journee: null,
    }
  },
  components: {},
  methods: {
    ...mapMutations([]),
    ...mapActions([
      'axiosGetOneData'
    ]),
  },
  computed: {
    ...mapGetters([])
  },
  beforeCreate() {
  },
  created() {
    //
    this.axiosGetOneData({
      table: "equipes",
      table_id: this.resultat.equipe_a_id
    })
        .then((data) => {
          this.equipe_a = data.data
        })
        .catch((error) => {

        })
    //
    this.axiosGetOneData({
      table: "equipes",
      table_id: this.resultat.equipe_b_id
    })
        .then((data) => {
          this.equipe_b = data.data
        })
        .catch((error) => {

        })
    //
    this.axiosGetOneData({
      table: "terrains",
      table_id: this.resultat.terrain_id
    })
        .then((data) => {
          this.terrain = data.data
        })
        .catch((error) => {

        })
    //
    this.axiosGetOneData({
      table: "arbitres",
      table_id: this.resultat.arbitre_principal_id
    })
        .then((data) => {
          this.arbitre_principal = data.data
        })
        .catch((error) => {

        })
    //
    this.axiosGetOneData({
      table: "arbitres",
      table_id: this.resultat.arbitre_assistant_1_id
    })
        .then((data) => {
          this.arbitre_assistant_1 = data.data
        })
        .catch((error) => {

        })
    //
    this.axiosGetOneData({
      table: "arbitres",
      table_id: this.resultat.arbitre_assistant_2_id
    })
        .then((data) => {
          this.arbitre_assistant_2 = data.data
        })
        .catch((error) => {

        })
    //
    this.axiosGetOneData({
      table: "arbitres",
      table_id: this.resultat.arbitre_commissaire_id
    })
        .then((data) => {
          this.arbitre_commissaire = data.data
        })
        .catch((error) => {

        })
    //
    this.axiosGetOneData({
      table: "saisons",
      table_id: this.resultat.saison_id
    })
        .then((data) => {
          this.saison = data.data
        })
        .catch((error) => {

        })
    //
    this.axiosGetOneData({
      table: "championnats",
      table_id: this.resultat.championnat_id
    })
        .then((data) => {
          this.championnat = data.data
        })
        .catch((error) => {

        })
  },
  beforeMount() {
  },
  mounted() {
  },
  beforeUpdate() {
  },
  updated() {
  },
  beforeDestroy() {
  },
  destroyed() {
  }
}
</script>

<style lang="scss" scoped>
form {
  & > div {
    & > div {
      & > span, & > label {
        background-color: var(--color-curious-blue, rgba(34, 134, 195, 1));
        color: var(--color-white, rgba(255, 255, 255, 1));
        border-color: var(--color-curious-blue, rgba(34, 134, 195, 1));
      }

      & > span.customized-span {
        padding: 0.25rem 0.5rem;
        font-size: 0.875rem;
        line-height: 1.5;
        border-radius: 0.2rem;
      }
    }

    & > input, & > select {
      border-color: var(--color-curious-blue, rgba(34, 134, 195, 1));
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/resultats/components/Read.vue